import YFormCouponCodeGenerate from './CouponCodeGenerate';

export { YFormCouponCodeGenerate };
export default YFormCouponCodeGenerate;
